import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import type { Special } from '../../../types/toppage';
import { getSpecials } from '../../../services/toppage';

export const Component: FunctionComponent = () => {
  const [special, setSpecial] = useState<Special[]>([]);

  useEffect(() => {
    const request = async () => {
      try {
        const data = await getSpecials();
        setSpecial(data);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, []);

  return <Presentation specials={special} />;
};
